import moment from 'moment-timezone';
import React from 'react'

interface PersonalSueDetailsProps {
    customer: any;
    sueData: any;
    address: any;
    gender: string;
    customerPhone: string;
    customerEmail: string;
}


const PersonalSueDetails = (props: PersonalSueDetailsProps) => {
    return (
        <div className='white-block top-white-block'>
            <div className="block-title">
                פרטים אישיים
            </div>
            <div className="parameter-row">
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            {props.customer && props.customer.identityType == 3 ? 'שם חברה' : 'שם מלא'}
                        </div>
                        <div className="value">
                            {props.customer && props.customer.fullName}
                        </div>
                    </div>
                </div>
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            {props.customer && props.customer.identityType == 3 ? 'ח.פ' : 'ת.ז'}
                        </div>
                        <div className="value">
                            {props.customer && props.customer.identifier}
                        </div>
                    </div>
                </div>
                {props.customer && props.customer.identityType == 1 &&
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מגדר
                            </div>
                            <div className="value">
                                {props.gender}

                            </div>
                        </div>
                    </div>
                }
                {props.customer && props.customer.identityType == 1 &&
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                רישיון
                            </div>
                            <div className="value">
                                {props.customer && props.customer.driverLicenseNumber}
                            </div>
                        </div>
                    </div>
                }
                {props.customer && props.customer.identityType == 1 &&
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                ת. לידה
                            </div>
                            <div className="value">
                                {props.customer && props.customer.dateOfBirth && moment(props.customer.dateOfBirth).format('DD-MM-YYYY')}
                            </div>
                        </div>
                    </div>
                }
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            כתובת
                        </div>
                        <div className="value">
                            {props.address.city ? <>
                                {props.address.street} {props.address.houseNumber}, {props.address.city}
                            </> : <>
                            </>}
                        </div>
                    </div>
                </div>

            </div>
            <div className="parameter-row">
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            טלפון נייד
                        </div>
                        <div className="value">
                            <input type="text" value={props.customerPhone} onChange={(e: any) => { }} onBlur={(e: any) => { }} />
                        </div>
                    </div>
                </div>
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            מייל
                        </div>
                        <div className="value">
                            {props.customerEmail}
                        </div>
                    </div>
                </div>
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            מסמכים
                        </div>
                        <div className="value">
                            {props.sueData.documents && props.sueData.documents.length}
                        </div>
                    </div>
                </div>
                <div className="parameter-item">
                    <div className="field">
                        <div className="title">
                            התקשרויות
                        </div>
                        <div className="value">

                        </div>
                    </div>
                </div>
                <div className="parameter-item"></div>
                <div className="parameter-item"></div>
                <div className="parameter-item"></div>
                <div className="parameter-item"></div>
            </div>
        </div>
    )
}

export default PersonalSueDetails